import type { HabitRow } from '@st/contract';
import { addDays } from './format';

export interface HabitCell {
  day: string;
  done: boolean;
  value: number | null;
}

/**
 * Mreža zadnjih `days` dana koja završava na `to` (uključivo).
 *
 * Server vraća SAMO dane koji su ispunjeni (`history`), pa rupe mora dodati
 * klijent — inače bi mreža imala manje kvadratića nego dana i heatmap bi lagao.
 * Redoslijed je od najstarijeg prema danas, isto kao što se čita.
 */
export function habitGrid(
  history: readonly { day: string; value: number | null }[],
  to: string,
  days = 30,
): HabitCell[] {
  const byDay = new Map(history.map((h) => [h.day, h.value]));
  const cells: HabitCell[] = [];
  for (let i = days - 1; i >= 0; i -= 1) {
    const day = addDays(to, -i);
    cells.push({ day, done: byDay.has(day), value: byDay.get(day) ?? null });
  }
  return cells;
}

/** Intenzitet kvadratića 0–3 — jedan ton (accent), svjetlije → tamnije. */
export function habitIntensity(cell: HabitCell, target: number | null): 0 | 1 | 2 | 3 {
  if (!cell.done) return 0;
  if (target === null || target <= 0 || cell.value === null) return 3;
  const ratio = cell.value / target;
  if (ratio >= 1) return 3;
  if (ratio >= 0.6) return 2;
  return 1;
}

/** Ključ navike koji API prihvaća: mala slova, brojke i podvlaka. */
export const HABIT_KEY_PATTERN = /^[a-z0-9_]{2,40}$/;

export function slugifyHabitKey(label: string): string {
  const map: Record<string, string> = { č: 'c', ć: 'c', đ: 'd', š: 's', ž: 'z' };
  return label
    .toLowerCase()
    .replace(/[čćđšž]/g, (m) => map[m] ?? m)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40);
}

/** Navike s najdužim nizom prve — trud koji traje mora biti vidljiv na vrhu. */
export function sortHabits(items: readonly HabitRow[]): HabitRow[] {
  return [...items].sort((a, b) => b.streak - a.streak || a.label.localeCompare(b.label));
}
